/**
 * A day or a run of days, for the lists of slips and orders. Off by default,
 * showing the latest; switched on, the list is just those days.
 */
import { useState } from 'react';
import { today } from '@foodrun/shared';

import { RangeInputs } from '../reports/DashboardPage.jsx';
import { Button } from '../../components/ui/Button.jsx';

export function useDateFilter() {
  const [range, setRange] = useState(null);
  return { range, setRange, query: range ? `&from=${range.from}&to=${range.to}` : '' };
}

export function DateFilter({ range, onChange }) {
  const t = today();
  return (
    <div className="flex flex-wrap items-center gap-2">
      {range ? (
        <>
          <RangeInputs range={range} latest={t} onRange={onChange} />
          <Button size="sm" variant="ghost" onClick={() => onChange(null)}>
            All
          </Button>
        </>
      ) : (
        <Button size="sm" variant="secondary" onClick={() => onChange({ from: t, to: t })}>
          Filter by date
        </Button>
      )}
    </div>
  );
}
